/* Ayudate · El logotipo: el isotipo y la palabra al lado.

   El isotipo es el de logos_y_estilos/ayudate-isotipo.svg, y la palabra va
   entera y de un solo color — como en las tres versiones de referencia
   (logos_y_estilos/ayudate-logo-blanco|oscuro|turquesa.png). Antes la A
   vivía dentro de un cuadro turquesa y hacía de logo ella misma; eso quedó
   atrás: ahora el símbolo es su propia pieza y la palabra vuelve a ser una
   palabra.

   Vive en su propio componente porque el logotipo aparece en trece lugares
   —la barra pública, el pie, los tres paneles, el login, las páginas de
   restablecer contraseña, calificar, la sala y el 404— y hasta hace poco
   cada uno lo escribía a mano.

   VA EN LÍNEA Y NO COMO <img>
   El logotipo está en la barra fija de todas las páginas, arriba del todo:
   una etiqueta <img> lo dejaría en blanco hasta que llegue la respuesta,
   justo en el primer cuadro que se pinta. En línea se dibuja con el HTML.
   El costo es tener el mismo dibujo dos veces en el repositorio — acá y en
   public/icono.svg, que es el que necesita el <link rel="icon"> del
   navegador. Si el símbolo cambia, hay que cambiarlo en los dos, más el
   original de logos_y_estilos/.

   LA FIGURA INTERIOR VA PINTADA DE BLANCO, NO RECORTADA
   En el archivo original está hecha con una máscara: es un agujero que
   deja ver lo que haya detrás. Sobre el papel blanco del manual se ve
   blanca, pero sobre el #09090B del sitio saldría casi negra. Pintada de
   blanco se ve igual contra cualquier fondo.

   `sufijo` es para cuando el logotipo además es un enlace y conviene decir
   a dónde lleva ("Ayudate · Inicio"). El que lo usa pone el contenedor con
   la clase .logo (un <div>, un <span> o un <a>, según le sirva); acá va
   solo el contenido. */

import React, { useId } from "react";

export function Marca({ sufijo = "" }) {
  /* El degradado se referencia por id, y el logotipo aparece dos veces en
     la misma página (la barra y el pie): con un id fijo, el segundo lo
     buscaría en el primero. useId da uno distinto por instancia. */
  const grad = `ay-grad-${useId()}`;

  return (
    <>
      <svg className="iso" viewBox="2 2 236 236" aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id={grad} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#2FBCA9" />
            <stop offset="1" stopColor="#12988A" />
          </linearGradient>
        </defs>
        <rect fill={`url(#${grad})`} x="2" y="2" width="236" height="236" rx="52" />
        <g fill="#fff">
          <path d="M 103.8,85.0 A 14.9,18.5 0 0 1 133.6,85.0 L 133.6,112.6 L 103.8,112.6 Z" />
          <path d="M 79.2,100.6 L 158.2,100.6 A 10.7,10.7 0 0 1 168.9,111.3 L 168.9,130.6 A 20.1,20.1 0 0 1 148.8,150.7 L 88.6,150.7 A 20.1,20.1 0 0 1 68.5,130.6 L 68.5,111.3 A 10.7,10.7 0 0 1 79.2,100.6 Z" />
          <path d="M 92.7,146.7 L 94.0,148.1 L 95.3,149.5 L 96.5,151.0 L 97.8,152.4 L 99.0,153.8 L 100.3,155.3 L 101.5,156.7 L 102.7,158.1 L 103.8,159.6 L 105.0,161.0 L 106.1,162.4 L 107.2,163.9 L 108.3,165.3 L 109.3,166.7 L 110.3,168.2 L 111.3,169.6 L 112.3,171.0 L 113.2,172.5 L 114.1,173.9 L 114.9,175.3 L 115.7,176.8 L 116.5,178.2 L 117.2,179.6 L 117.8,181.1 L 118.3,182.5 L 118.7,183.9 L 118.7,183.9 L 119.1,182.5 L 119.6,181.1 L 120.2,179.6 L 120.9,178.2 L 121.7,176.8 L 122.5,175.3 L 123.3,173.9 L 124.2,172.5 L 125.1,171.0 L 126.1,169.6 L 127.1,168.2 L 128.1,166.7 L 129.1,165.3 L 130.2,163.9 L 131.3,162.4 L 132.4,161.0 L 133.6,159.6 L 134.7,158.1 L 135.9,156.7 L 137.1,155.3 L 138.4,153.8 L 139.6,152.4 L 140.9,151.0 L 142.1,149.5 L 143.4,148.1 L 144.7,146.7 Z"
            stroke="#fff" strokeWidth="3.5" strokeLinejoin="round" strokeLinecap="round" />
        </g>
      </svg>
      <span className="marca" translate="no">Ayudate</span>
      {sufijo ? <span className="sr-only"> · {sufijo}</span> : null}
    </>
  );
}
